/* eslint-disable */

export enum ToolboxSearchSource {
  GENERAL = 0,
  NEWS = 2,
  PEOPLE = 3,
  SALES_PACKAGE = 4,
  UNRECOGNIZED = -1,
}

export interface ToolboxSearchResult {
  id: string;
  created: string;
  title: string;
  description: string;
  url: string;
  image: string;
  topics: string[];
  likeCount?: number | undefined;
  commentCount?: number | undefined;
  userHasLiked?: boolean | undefined;
}

export interface ToolboxUser {
  title: string;
  email: string;
  jobTitle: string;
  phone: string;
  company: string;
}

export interface SearchToolboxRequest {
  query: string;
  source: ToolboxSearchSource;
  top: number;
}

export interface ToolboxSearchResultList {
  items: ToolboxSearchResult[];
  users: ToolboxUser[];
  count: number;
}

export interface ToolboxNewsRequest {
  pageNumber: number;
  pageSize: number;
  tab: string;
  category: string;
}
